import { useEffect } from 'react';
import { SkipDirection } from '@/components/VideoPlayer/hooks/useSkipIndicator';
import { createPlayerKeyHandler } from '@/utils/video-player';
import { SKIP_SECONDS } from '@/constants/video-player';

interface UsePipPlayerKeyboardShortcutsProps {
    live: boolean;
    togglePlay: () => void;
    onSkip: (seconds: number, direction: SkipDirection) => void;
}

export function usePipPlayerKeyboardShortcuts({
    live,
    togglePlay,
    onSkip,
}: UsePipPlayerKeyboardShortcutsProps) {
    useEffect(() => {
        const handleKeyDown = createPlayerKeyHandler({
            live,
            togglePlay,
            skip: (seconds) =>
                onSkip(
                    seconds,
                    seconds < 0
                        ? SkipDirection.Backward
                        : SkipDirection.Forward,
                ),
            skipSeconds: SKIP_SECONDS,
        });

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [live, togglePlay, onSkip]);
}
